import { Spinner } from "react-bootstrap";

const SpinnerDiv = () => {
    return (
        <Spinner animation="border" variant="success" role="status" size="sm" />
    );
};

export default SpinnerDiv;
